import { Button, Col, Form, Input, Row, Select } from "antd";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";

export const OnSiteRegisterFilter = ({
  formFilter,
  handleFormChange,
  filter,
  setFilter,
  handleFilterChange,
  handleFilter,
  handleReset,
  modifiedOems,
  modifiedDealers,
}) => {
  const logData = JSON.parse(sessionStorage.getItem("userData"));

  return (
    <div>
      <Form form={formFilter} onValuesChange={handleFormChange}>
        <div className="mt-2">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
              <Input
                className="input_text_3 mr10 h-full"
                name="RegisterNo"
                placeholder="No"
                value={filter.RegisterNo}
                onChange={(e) => {
                  const { value } = e.target;
                  // Allow only positive integers or empty string
                  if (/^[1-9]\d*$/.test(value) || value === "") {
                    handleFilterChange(e);
                  }
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <CustomDateTimePicker
                name="RegisterTime"
                placeholder="Register Time"
                format="YYYY-MM-DD HH:mm"
              />
            </Col>
            {![4, 5, 6, 7, 8, 9].includes(logData?.role_value) && (
              <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                <Select
                  showSearch
                  placeholder="OEM"
                  optionFilterProp="label"
                  value={
                    filter.OemNo || typeof filter.OemNo === "number"
                      ? Number(filter.OemNo)
                      : null
                  }
                  onChange={(value) => setFilter({ ...filter, OemNo: value })}
                  options={modifiedOems}
                  style={{ width: "100%" }}
                  allowClear
                />
              </Col>
            )}
            {![7, 8, 9].includes(logData?.role_value) && (
              <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                <Select
                  showSearch
                  placeholder="Dealer"
                  optionFilterProp="label"
                  value={
                    filter.DealerNo || typeof filter.DealerNo === "number"
                      ? Number(filter.DealerNo)
                      : null
                  }
                  onChange={(value) =>
                    setFilter({ ...filter, DealerNo: value })
                  }
                  options={modifiedDealers}
                  style={{ width: "100%" }}
                  allowClear
                />
              </Col>
            )}
            <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
              <Input
                className="input_text_3 mr10 h-full"
                name="Mac"
                placeholder="MAC"
                value={filter.Mac}
                onChange={handleFilterChange}
              />
            </Col>
          </Row>
        </div>
      </Form>

      <div className="w-full overflow-x-auto">
        <div className="flex justify-between my-4 flex-nowrap min-w-[610px]">
          <div className="flex items-center">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              onClick={handleFilter}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button className="reset-button" onClick={handleReset}>
              <HiArrowPath className="!text-[14px] font-medium" />
              Reset
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
